(function(){
     'use strict';

     angular
        .module('appback')
        .factory('InformeService', InformeService);

    InformeService.$inject = ['$http'];

    function InformeService($http){


        var service= {
           getAccionesUsuario:getAccionesUsuario,
           getIncidenciasUsuario:getIncidenciasUsuario,
           getGenericoUser:getGenericoUser,
           getContrastaciones:getContrastaciones
        };

        return service;
 		function getAccionesUsuario(fecha_inicial,fecha_final,users,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
            	fecha_inicial:fecha_inicial,
            	fecha_final:fecha_final,
            	users:users
            });
            $http.post('/backend/informeacciones/accionesusuario', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function getContrastaciones(fecha_inicial,fecha_final,users,filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                fecha_inicial:fecha_inicial,
                fecha_final:fecha_final,
                users:users,
                filtros:filtros
            });
            $http.post('/backend/informeacciones/getcontrastaciones', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function getGenericoUser(fecha_inicial,fecha_final,users,filtrosAcciones,filtrosCuentas,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                fecha_inicial:fecha_inicial,
                fecha_final:fecha_final,
                users:users,
                filtrosAcciones:filtrosAcciones,
                filtrosCuentas:filtrosCuentas
            });
            $http.post('/backend/informeacciones/getgenerico', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function getIncidenciasUsuario(fecha_inicial,fecha_final,users,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                fecha_inicial:fecha_inicial,
                fecha_final:fecha_final,
                users:users
            });
            $http.post('/backend/informeacciones/incidenciasusuario', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                return false;
            }
        }
    }
})();